import Dropdown from 'assets/icons/Dropdown';
import { PropsWithChildren, useEffect, useState } from 'react';
import COLOR from 'constants/color';
import { KEY_BOARD } from 'constants/general';
import { TAB_INDEX } from 'constants/attrib';

interface AccordionProps {
  title?: string | JSX.Element;
  open?: boolean;
  wrapperStyles?: string;
  icon?: JSX.Element;
  onHeaderClick?: () => void;
  headerTitleStyles?: string;
}

const Accordion = ({
  title,
  children,
  open = false,
  wrapperStyles,
  icon,
  onHeaderClick,
  headerTitleStyles = 'font-normal ~text-xs/base'
}: PropsWithChildren<AccordionProps>) => {
  const [isOpen, setIsOpen] = useState(open);

  useEffect(() => {
    setIsOpen(open);
  }, [open]);

  return (
    <div
      className={`w-full h-fit flex flex-col rounded-md shadow-sm ${wrapperStyles}`}
    >
      <div
        className='w-full h-fit flex items-center justify-between rounded-t-md ~px-2/3 ~py-1/2 dark:bg-secondary-dark-300 dark:text-secondary-dark-900 bg-primary-50 border-b-2 border-primary-100 dark:border-secondary-dark-500'
        role='button'
        tabIndex={TAB_INDEX.DEFAULT}
        onClick={() => {
          setIsOpen((prev) => !prev);
          onHeaderClick?.();
        }}
        onKeyDown={(event) => {
          if ([KEY_BOARD.ENTER.KEY, KEY_BOARD.SPACE.KEY].includes(event.key)) {
            event.preventDefault();
            setIsOpen((prev) => !prev);
            onHeaderClick?.();
          }
        }}
      >
        <h6 className={headerTitleStyles}>{title}</h6>
        <button
          className={`${isOpen ? 'rotate-180' : 'rotate-0'} duration-200`}
        >
          {icon ?? (
            <Dropdown styles='~w-5/7 h-auto' fill={COLOR.PRIMARY.LIGHT_900} />
          )}
        </button>
      </div>
      <div
        className={`w-full ${
          isOpen
            ? `h-fit overflow-y-auto scrollbar-thin scrollbar-thumb-gray-400 dark:scrollbar-thumb-secondary-dark-500 ~px-2/3 ~py-3/4`
            : 'h-0 p-0 overflow-hidden'
        } transition-all duration-200 rounded-b-md bg-secondary-50 dark:bg-secondary-dark-200`}
      >
        {isOpen && children}
      </div>
    </div>
  );
};

export default Accordion;
